import styled from 'react-emotion'

export const BlogPageContainer = styled('div')`
  font-size: 1rem;
`

export const BodyLayoutContainer = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (min-width: 320px) and (max-width: 425px) {
    width: 100%;
    margin-top: 20px;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    width: 100%;
    margin-top: 20px;
  }
  margin-left: auto;
  margin-right: auto;
`

export const ImageItemContainer = styled('div')`
  cursor: pointer;
`
export const BodyContainer = styled('div')`
  padding-bottom: 20px;
  margin-top: 4.35em;
  font-size: 1em;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/templates/albumPageStyledComponents.js